import UpdateAccount from './UpdateAccount'
import EmailChangedSuccessfully from './EmailChangedSuccessfully/EmailChangedSuccessfully'

export { EmailChangedSuccessfully }
export default UpdateAccount
